import React from "react";
import FooterStyle from "./FooterStyle.module.css";
//import icons from material
import InstagramIcon from '@mui/icons-material/Instagram';
import TelegramIcon from '@mui/icons-material/Telegram';
//import img
import img from "../../assets/digital.png"
import img1 from "../../assets/endcredit.png"


const Footer = () => {
  return (
    <div className={FooterStyle.container}>
      <div className={FooterStyle.partOne}>
          <h2>academy</h2>
          <div className={FooterStyle.icons}>
        <a href="https://instagram.com/mohammadpoulani" ><InstagramIcon sx={{ fontSize: 26 }} color="disabled"/></a>
        <a href="https://t.me/mhplny" style={{marginRight:'15px'}}> <TelegramIcon color="disabled" sx={{ fontSize: 26}}/></a>
        </div>
        <p>تمامی حقوق برای آکادمی محفوظ است</p>
      </div>
      <div className={FooterStyle.partTwo}> <a href="#" ><img alt="top" style={{width: "100%"}} src={img}/></a>
        <a href="#" style={{marginRight:'15px'}}> <img alt="top" style={{width: "100%"}} src={img1}/></a></div>
      <div></div>
    </div>
  );
};

export default Footer;
